import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SelectedProjectListControllerComponent } from '../selected-project-list-controller/selected-project-list-controller.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { Subject, take, takeUntil } from 'rxjs';
import { EmbedData } from '../../data/embed';
import { FormsModule } from '@angular/forms';
import {
  PartModel,
  Template,
} from '../../../../workspace-layout/commons/services/project-controller/project-controller';
@Component({
  selector: 'part-setting-tool',
  imports: [
    CommonModule,
    FormsModule,
    MatSlideToggleModule,
    MatTabsModule,
    SelectedProjectListControllerComponent,
  ],
  templateUrl: './part-setting-tool.component.html',
  styleUrl: './part-setting-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartSettingToolComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  public isPartChange: boolean = false;

  public embedData: EmbedData | undefined;
  public selectedTemplate: Template | undefined;

  public selectedProjectIndex: number = 0;

  private unsubscribeAll: Subject<any> = new Subject();
  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private embedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getEmbedData();
    this.getSelectedProjectIndex();
  }

  ngOnDestroy(): void {}

  public onChangeIsPart(): void {
    if (!this.embedData) return;
    if (!this.embedData.projects[this.selectedProjectIndex].setting)
      this.embedData.projects[this.selectedProjectIndex].setting = {};
    this.embedData.projects[this.selectedProjectIndex].setting['isPart'] = this.isPartChange;
    console.log('onChangeIsPart');

    this.embedService.embedData = this.embedData;
    this.threeGraphqlService
      .updateEmbedProject(
        this.embedData.projects[this.selectedProjectIndex].uuid,
        this.embedData.projects[this.selectedProjectIndex].setting,
      )
      .pipe(take(1))
      .subscribe((res: any) => {});
  }

  public isSelectedPart(partModel: PartModel): boolean {
    if (!this.embedData) return false;
    return (
      this.embedData.projects[this.selectedProjectIndex]?.partModels?.filter(
        (part: PartModel) => part.uuid === partModel.uuid,
      ).length > 0
    );
  }

  public onClickPart(partModel: PartModel): void {
    if (!this.isSelectedPart(partModel)) this.addPartModelToProject(partModel);
    else this.removePartModelFromProject(partModel);
  }

  private getEmbedData(): void {
    this.embedService.embedData$.pipe(takeUntil(this.unsubscribeAll)).subscribe((embedData) => {
      if (!embedData) return;
      this.embedData = embedData;
      this.isPartChange =
        this.embedData?.projects[this.selectedProjectIndex]?.setting?.isPart || false;
      if (this.embedData?.projects[this.selectedProjectIndex]?.template) {
        this.threeGraphqlService
          .getTempleteByUuid(this.embedData?.projects[this.selectedProjectIndex]?.template.uuid)
          .pipe(take(1))
          .subscribe((template: Template | undefined) => {
            if (!template) return;
            this.selectedTemplate = template;
            this.cd.markForCheck();
          });
      }
      this.cd.markForCheck();
    });
  }

  private getSelectedProjectIndex(): void {
    this.embedService.selectedProjectIndex$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((index) => {
        this.selectedProjectIndex = index;

        this.isPartChange =
          this.embedData?.projects[this.selectedProjectIndex]?.setting?.isPart || false;
        if (this.embedData?.projects[this.selectedProjectIndex]?.template) {
          this.threeGraphqlService
            .getTempleteByUuid(this.embedData?.projects[this.selectedProjectIndex]?.template.uuid)
            .pipe(take(1))
            .subscribe((template: Template | undefined) => {
              if (!template) return;
              this.selectedTemplate = template;
              this.cd.markForCheck();
            });
        }
        this.cd.markForCheck();
      });
  }

  private addPartModelToProject(partModel: PartModel): void {
    if (!this.embedData) return;
    this.embedData.projects[this.selectedProjectIndex].partModels.push(partModel);
    console.log('addPartModelToProject');

    this.embedService.embedData = this.embedData;
    this.threeGraphqlService
      .addPartModelInProject(
        this.embedData.projects[this.selectedProjectIndex].uuid,
        partModel.uuid,
      )
      .pipe(take(1))
      .subscribe((res: any) => {
        this.cd.markForCheck();
      });
  }

  private removePartModelFromProject(partModel: PartModel): void {
    if (!this.embedData) return;
    this.embedData.projects[this.selectedProjectIndex].partModels = this.embedData.projects[
      this.selectedProjectIndex
    ].partModels.filter((part: PartModel) => part.uuid !== partModel.uuid);
    console.log('removePartModelFromProject');
    this.embedService.embedData = this.embedData;

    this.threeGraphqlService
      .deletePartModelInProject(
        this.embedData.projects[this.selectedProjectIndex].uuid,
        partModel.uuid,
      )
      .pipe(take(1))
      .subscribe((res: any) => {
        this.cd.markForCheck();
      });
  }
}
